import React from "react";
import styles from "./broadCastMessage.module.scss";
import URBroadCast from "../broadCast";
import {  LoginState } from "../../../../models/model";
import store from "../../../../context/store/store";
import { useState } from "react";
import { useEffect } from "react";

type broadcastMessageProps = {

  data:any
  keyRes:any;
}
type broadCaststate ={
  middle:any;
  endDetail:string;
  allMem:any
}
export default function URBroadcastMessage({ data,keyRes }: broadcastMessageProps) {
  let loginDetails: LoginState = store.getState().loginReducer;
  let { userdetails } = loginDetails;
  let { workContactsnew }: any= store.getState().contactReducer;
  let {  message, fromcaller_details } = data;
  let description: any = message?.teamAction?.actionKey;
  const [broadcast, setBroadcast]=useState<broadCaststate>({
    middle:"",
    endDetail:"",
    allMem:[]
  })
  

  const allMembers = () => {
    let name: any = message?.teamAction?.members?.toString().split(",");
    let broadcastnamedetails: any =[];
    Array.isArray(name) && name.length>0 && 
    name.forEach((el: any) => {
      broadcastnamedetails.push(workContactsnew[el]);
    });
    if(broadcastnamedetails.includes(userdetails)){
      broadcastnamedetails =  broadcastnamedetails.filter((item:any) => item?.sip_login_id !== userdetails?.sip_login_id);
      broadcastnamedetails.unshift(userdetails);
    }

  let innerText = description ==="add_member" ? ` added`:description === "create_group" ? ` created contact group `+ data?.message?.team_name :
                  description ==="remove_member" ? ``:description ==="make_admin" || description ==="make_member" ?` `:description ==="leave_member"&&` left`
  let EndoutText = description ==="remove_member" ? " was removed from this group": description ==="make_admin" ? " has been made an admin ": description ==="make_member"?" role was changed to member":
                  description ==="leave_member"?' the team':description === "update_group" ? message?.teamAction?.description==="group image updated"?" updated team Profile": 
                  message?.teamAction?.description.includes("edited the team description. Tap to view")? ` ${ message?.teamAction?.description.split(".")[0]}`:
                  message?.body === "Group description updated"?" changed the group description":
                  message?.body === "Group Name updated"?` changed the group name to  ${data?.message?.team_name}`:
                 ` ${ message?.teamAction?.description}` :"";

  setBroadcast({...broadcast,middle:innerText,endDetail:EndoutText,allMem:broadcastnamedetails});


  }

  useEffect(() => {
    allMembers();
  }, [data]);

  return (
    <React.Fragment key={keyRes}>

      <div className={`${styles.chatMsg} ${styles.broadCastMessage}`}>       
          <div className={styles.chatLeftMessages}>
              <>
                {description !=="remove_member" && description !=="make_admin" && description !=="make_member" && fromcaller_details?.sip_login_id === userdetails?.sip_login_id ? 
                 `You `: description !=="remove_member" &&  description !=="make_admin" &&description !=="make_member" &&  <><URBroadCast key={keyRes} name={fromcaller_details} className='broadCastMessage' /></> }
                 {broadcast.middle}
                {description === "make_admin" || description === "make_member" ||description === "add_member"
                ||description === "remove_member" ?
                  <>
                  {broadcast.allMem.length>0 && broadcast.allMem?.map((list: any) => 
                    broadcast.allMem.length===1&&list?.sip_login_id===userdetails?.sip_login_id? ` you` :
                    broadcast.allMem.length===2&&list?.sip_login_id===userdetails?.sip_login_id? ` you and ` :
                    broadcast.allMem.length>2&&list?.sip_login_id===userdetails?.sip_login_id? ` you ` :
                    <URBroadCast  keydata={keyRes} name={list} className='broadCastMessage' /> ) 
                   }
                  </>:null
                }{broadcast.endDetail}
               </>
          </div>     
        </div>
    </React.Fragment>
  );
};

